var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-menu",
    { staticClass: "k-admin-menu" },
    [
      _c(
        "w-menu-action",
        { attrs: { to: "/admin/main" } },
        [
          _c("i-dashboard", { attrs: { slot: "icon" }, slot: "icon" }),
          _vm._v("Dashboard"),
        ],
        1
      ),
      _c(
        "w-menu-action",
        { attrs: { to: "/admin/programs" } },
        [
          _c("i-program", { attrs: { slot: "icon" }, slot: "icon" }),
          _vm._v("Programs"),
        ],
        1
      ),
      _c(
        "w-menu-action",
        { attrs: { to: "/admin/content" } },
        [
          _c("i-content", { attrs: { slot: "icon" }, slot: "icon" }),
          _vm._v("Content"),
        ],
        1
      ),
      _c(
        "k-menu",
        [
          _c(
            "w-menu-action",
            { attrs: { to: "/admin/content/videos" } },
            [
              _c("i-video", { attrs: { slot: "icon" }, slot: "icon" }),
              _vm._v("Videos"),
            ],
            1
          ),
          _c(
            "w-menu-action",
            { attrs: { to: "/admin/content/audios" } },
            [
              _c("i-audio", { attrs: { slot: "icon" }, slot: "icon" }),
              _vm._v("Audio Files"),
            ],
            1
          ),
          _c(
            "w-menu-action",
            { attrs: { to: "/admin/content/new" } },
            [
              _c("i-upload", { attrs: { slot: "icon" }, slot: "icon" }),
              _vm._v("Recent Uploads"),
            ],
            1
          ),
          _c(
            "w-menu-action",
            { attrs: { to: "/admin/content/collections" } },
            [
              _c("i-collection", { attrs: { slot: "icon" }, slot: "icon" }),
              _vm._v("Collections"),
            ],
            1
          ),
          _c(
            "w-menu-action",
            { attrs: { to: "/admin/content/tags" } },
            [
              _c("i-tag", { attrs: { slot: "icon" }, slot: "icon" }),
              _vm._v("Tags"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-menu-action",
        { attrs: { to: "/admin/settings" } },
        [
          _c("i-settings", { attrs: { slot: "icon" }, slot: "icon" }),
          _vm._v("Settings"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }